import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import './tinyLoader.scss';


export default function TinyLoader(){
    return <HourglassEmptyIcon className="loading_icon" fontSize="large"/>
}